import {
  Avatar,
  Button, // RadioGroup,
  // FormControl,
  // FormControlLabel,
  // Radio,
  Grid,
  MenuItem,
  Theme,
  Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Formik } from 'formik';
import { useEffect, useMemo, useRef, useState } from 'react';
import { LabelledOutline } from '../../../common/final-form-material-ui';
import {
  FormikSelect,
  FormikTextField,
  MaterialAutocomplete,
} from '../../../common/formik-material-ui';
import { ISchedulableHours } from '../../../lib/kixie-entities/interfaces/ISchedulableHours';
import {
  createHoursString,
  Scheduler,
} from '../../components/CadenceSettings/Scheduler';
import { ModalWithStyles } from '../../components/modals/ModalWithStyles';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import * as Yup from 'yup';
import activecampaign from '../../../images/crm-logos/activecampaign-logo.jpeg';
import amocrm from '../../../images/crm-logos/amocrm-logo.jpeg';
import capsule2 from '../../../images/crm-logos/capsule2-logo.jpeg';
import contactually from '../../../images/crm-logos/contactually-logo.jpeg';
import custom from '../../../images/crm-logos/custom-logo.jpeg';
import freshsales from '../../../images/crm-logos/freshsales-logo.jpeg';
import hubspot from '../../../images/crm-logos/hubspot-logo.jpeg';
import insightly from '../../../images/crm-logos/insightly-logo.jpeg';
import none from '../../../images/crm-logos/none-logo.jpeg';
import nutshell from '../../../images/crm-logos/nutshell-logo.jpeg';
import pipedrive from '../../../images/crm-logos/pipedrive-logo.jpeg';
import pipedrive2 from '../../../images/crm-logos/pipedrive2-logo.jpeg';
import pipelinedeals from '../../../images/crm-logos/pipelinedeals-logo.jpeg';
import prosperworks from '../../../images/crm-logos/prosperworks-logo.jpeg';
import salesforce from '../../../images/crm-logos/salesforce-logo.jpeg';
import gohighlevel from '../../../images/crm-logos/gohighlevel2-logo.jpeg';
import zendesk from '../../../images/crm-logos/zendesk-logo.jpeg';
import zoho from '../../../images/crm-logos/zoho-logo.jpeg';
import { Business } from '../../../lib/kixie-entities/tables/Business';
import {
  endpointEnum,
  makeApiRequestCached,
} from '../../../services/rest/makeAPIRequest';
import { countries as countryList } from '../../components/countries';
import { states as stateList } from '../../components/states';
import OnboardingSkeleton from './OnboardingSkeleton';

const useStyles = makeStyles((theme: Theme) => ({
  editButton: {
    maxWidth: '155px',
    maxHeight: '50px',
    minWidth: '155px',
    minHeight: '50px',
  },
  teamSelect: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    flexGrow: 1,
    width: '100%',
  },
  avatar: {
    boxShadow:
      '0 3px 3px rgb(200 200 210 / 75%), 0 2px 2px rgb(200 200 210 / 75%)',
    margin: '0px 8px 4px 8px',
    borderColor: theme.palette.primary.main,
    border: '2px solid',
    '& img': {
      maxWidth: '100%',
      height: 'auto',
    },
  },
  select: {
    '& input': {
      fontSize: '0.7rem',
      '& .MuiSelect-select:focus': {
        backgroundColor: theme.palette.primary.main,
      },
      color: theme.palette.primary.main,
      textShadow: `0 0 0 ${theme.palette.primary.main}`,
    },
  },
  crmImg: {
    width: '50%',
    // maxHeight: '50px',
    borderRadius: '8px',
    minWidth: '160px',
    maxWidth: '240px',
  },
  noDataContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  barSkeleton: {
    margin: 10,
    height: 40,
    backgroundColor: theme.palette.mode === 'dark' ? 'dimgray' : 'gainsboro',
  },
  barSkeleton80: {
    width: '80%',
  },
  barSkeleton70: {
    width: '70%',
  },
  barSkeleton40: {
    width: '40%',
  },
  barSkeleton20: {
    width: '20%',
  },
}));

export const getCRMName = (crmName: string) => {
  let crmDisplayName;
  switch (crmName?.toLowerCase?.()) {
    case 'pipelinedeals':
      crmDisplayName = 'Pipeline';
      break;
    case 'activecampaign':
      crmDisplayName = 'ActiveCampaign';
      break;
    case 'hubspot':
      crmDisplayName = 'HubSpot';
      break;
    case 'pipedrive':
      crmDisplayName = 'Pipedrive';
      break;
    case 'pipedrive2':
      crmDisplayName = 'Pipedrive Oauth';
      break;
    case 'freshsales':
      crmDisplayName = 'FreshSales';
      break;
    case 'contactually':
      crmDisplayName = 'Contactually';
      break;
    case 'insightly':
      crmDisplayName = 'Insightly';
      break;
    case 'salesforce':
      crmDisplayName = 'Salesforce';
      break;
    case 'zoho':
      crmDisplayName = 'Zoho CRM';
      break;
    case 'capsule2':
      crmDisplayName = 'Capsule';
      break;
    case 'amocrm':
      crmDisplayName = 'AmoCRM';
      break;
    case 'nutshell':
      crmDisplayName = 'Nutshell';
      break;
    case 'prosperworks':
      crmDisplayName = 'Copper';
      break;
    case 'zendesk':
      crmDisplayName = 'Zendesk';
      break;
    case 'custom':
      crmDisplayName = 'Custom';
      break;
    case 'none':
      crmDisplayName = `None`;
      break;
    case 'gohighlevel':
      crmDisplayName = `GoHighLevel`;
      break;
    case 'gohighlevel2':
      crmDisplayName = `GoHighLevel`;
      break;
    default:
      crmDisplayName = crmName;
  }
  return crmDisplayName;
};

export const getCRMIcon = (crmName: string) => {
  let crmIcon;
  switch (crmName?.toLowerCase?.()) {
    case 'pipelinedeals':
      crmIcon = pipelinedeals;
      break;
    case 'activecampaign':
      crmIcon = activecampaign;
      break;
    case 'hubspot':
      crmIcon = hubspot;
      break;
    case 'pipedrive':
      crmIcon = pipedrive;
      break;
    case 'pipedrive2':
      crmIcon = pipedrive2;
      break;
    case 'freshsales':
      crmIcon = freshsales;
      break;
    case 'contactually':
      crmIcon = contactually;
      break;
    case 'insightly':
      crmIcon = insightly;
      break;
    case 'salesforce':
      crmIcon = salesforce;
      break;
    case 'zoho':
      crmIcon = zoho;
      break;
    case 'capsule2':
      crmIcon = capsule2;
      break;
    case 'gohighlevel':
      crmIcon = gohighlevel;
      break;
    case 'gohighlevel2':
      crmIcon = gohighlevel;
      break;
    case 'amocrm':
      crmIcon = amocrm;
      break;
    case 'nutshell':
      crmIcon = nutshell;
      break;
    case 'prosperworks':
      crmIcon = prosperworks;
      break;
    case 'zendesk':
      crmIcon = zendesk;
      break;
    case 'custom':
      crmIcon = custom;
      break;
    case 'none':
      crmIcon = none;
      break;
    default:
      crmIcon = crmName;
  }
  return crmIcon;
};

const crmList = [
  'pipedrive2',
  'activecampaign',
  'amocrm',
  'gohighlevel',
  'gohighlevel2',
  'capsule2',
  // 'contactually',
  'freshsales',
  'hubspot',
  'insightly',
  'nutshell',
  'pipelinedeals',
  'prosperworks',
  'salesforce',
  'zoho',
  'zendesk',
  'custom',
  'none',
];

const AccountSettings = ({
  loading,
  userAtom,
  onboardingClasses,
  mutation,
  enqueueSnackbarWithStyles,
  handleStep,
  owWizardDataParsed,
}) => {
  // state for business hours modal;
  const [showBusinessHours, setShowBusinessHours] = useState(false);
  const handleShowBusinessHours = () => setShowBusinessHours(true);
  const onHideBusinessHours = () => setShowBusinessHours(false);
  const [hours, setHours] = useState();
  const [hoursString, setHoursString] = useState('');
  const splitHours = hoursString.split(',');
  const schedulableHoursCached = useRef<ISchedulableHours>();
  const handleSetSchedulableHours = (hours: ISchedulableHours) => {
    schedulableHoursCached.current = hours;
  };
  const classes = useStyles();

  const teamSelectOptions = ['1-5', '5-10', '10-25', '25-50', '50-100', '100+'];
  const [
    _businessCached,
    businessLoadable,
    refetchBusiness,
  ] = makeApiRequestCached<Business>(
    {
      endpoint: `${endpointEnum.GET_BUSINESSES}/${userAtom.businessid}`,
      method: 'get',
    },
    (loadable, cached) =>
      loadable.contents?.response?.data?.[0] ?? cached.current
  );

  useEffect(() => {
    refetchBusiness({});
  }, []);

  function handleSubmitBusinessHours(formik) {
    const hours =
      schedulableHoursCached?.current ??
      formik.values.businessHours ??
      emptyHoursObject;

    formik?.setFieldValue('businessHours', hours);
    onHideBusinessHours();
    setHours(hours);
  }

  const emptyHoursObject = {
    1: {
      day: 'Monday',
      hours: [],
    },
    2: {
      day: 'Tuesday',
      hours: [],
    },
    3: {
      day: 'Wednesday',
      hours: [],
    },
    4: {
      day: 'Thursday',
      hours: [],
    },
    5: {
      day: 'Friday',
      hours: [],
    },
    6: {
      day: 'Saturday',
      hours: [],
    },
    7: {
      day: 'Sunday',
      hours: [],
    },
  };

  const businessValidation = useMemo(
    () =>
      Yup.object().shape({
        businessName: Yup.string().required('required'),
        teamSize: Yup.string().required('required'),
        crm: Yup.string().required('required'),
        onlyManagersCanViewCallReporting: Yup.string().required('required'),
        location: Yup.object().shape({
          address1: Yup.string().required('required'),
          country: Yup.string().required('required'),
          city: Yup.string().required('required'),
          state: Yup.string().when('country', {
            is: (type) => type === 'US',
            then: Yup.string().required('required'),
          }),
          postalCode: Yup.string().when('country', {
            is: (type) => type === 'US',
            then: Yup.string().required('required'),
          }),
        }),
      }),
    []
  );

  useEffect(() => {
    businessLoadable?.state === 'hasValue' &&
      businessLoadable?.contents?.response?.data?.[0]?.businessDetails
        ?.businessHours &&
      setHours(
        businessLoadable?.contents?.response?.data?.[0]?.businessDetails
          ?.businessHours
      );
  }, [businessLoadable]);

  useEffect(() => {
    setHoursString(createHoursString(hours));
  }, [hours]);

  const businessInitialValues = useMemo(() => {
    const business = owWizardDataParsed?.business;
    return {
      businessName: businessLoadable?.contents?.response?.data?.[0]?.name ?? '',
      businessHours:
        businessLoadable?.contents?.response?.data?.[0]?.businessDetails
          ?.businessHours ?? emptyHoursObject,
      location: {
        fullName: business?.location?.fullName ?? '',
        address1: business?.location?.address1 ?? '',
        address2: business?.location?.address2 ?? '',
        city: business?.location?.city ?? '',
        state: business?.location?.state ?? 'CA',
        country: business?.location?.country ?? 'US',
        postalCode: business?.location?.postalCode ?? '',
      },
      teamSize: business?.teamSize ?? '',
      crm: business?.crm ?? '',
      onlyManagersCanViewCallReporting:
        businessLoadable?.contents?.response?.data?.[0]
          ?.onlyManagersCanViewCallReporting ?? 1,
    };
  }, [businessLoadable, owWizardDataParsed]);

  const handleNext = (_e, formik) => {
    if (formik.isValid) {
      formik.submitForm();
    }
  };

  return (
    <>
      {loading || businessLoadable.state !== 'hasValue' ? (
        <OnboardingSkeleton />
      ) : (
        <div style={{ padding: '24px' }}>
          <div style={{ fontWeight: 400, marginBottom: '24px' }}>
            <h1>Onboarding Walkthrough</h1>
            Welcome to Kixie! In this walkthrough, please add info about your
            business, teams, and agents. <br />
            Once finished, we’ll configure your account based on your selections
            and inputs.
          </div>
          <Typography
            className={onboardingClasses.onboardingSubtitle}
            variant={'h6'}
          >
            ACCOUNT
          </Typography>
          <Formik
            enableReinitialize={true}
            initialValues={businessInitialValues}
            validationSchema={businessValidation}
            onSubmit={async (values, _actions) => {
              const hasBusinessHoursChanged =
                JSON.stringify(businessInitialValues.businessHours) !==
                JSON.stringify(values?.businessHours);

              const hasBusinessNameChanged =
                businessInitialValues.businessName !== values?.businessName;

              const hasCallReportingChanged =
                Number(
                  businessLoadable?.contents?.response?.data?.[0]
                    ?.onlyManagersCanViewCallReporting
                ) !== Number(values?.onlyManagersCanViewCallReporting);

              const hasAnyAccountSettingsChanged =
                hasBusinessHoursChanged ||
                hasBusinessNameChanged ||
                hasCallReportingChanged;

              const updateOnboardingAccountSettings = () =>
                hasAnyAccountSettingsChanged
                  ? mutation.mutateAsync({
                      endpoint: endpointEnum.UPDATE_OW_ACCOUNT_SETTINGS,
                      domain: process.env.VITE_APP_CDK_DOMAIN,
                      method: 'put',
                      stage: 'itn',
                      payload: {
                        apiKey: userAtom?.apikey,
                        businessId: userAtom?.businessid,
                        businessName: values.businessName,
                        businessHours: JSON.stringify(values.businessHours),
                        onlyManagersCanViewCallReporting:
                          Number(values?.onlyManagersCanViewCallReporting) ===
                          1,
                      },
                    })
                  : Promise.resolve({
                      status: 200,
                    });

              const updateOnboardingWizard = () =>
                mutation.mutateAsync({
                  endpoint: endpointEnum.UPDATE_OW_WIZARD,
                  domain: process.env.VITE_APP_CDK_DOMAIN,
                  method: 'put',
                  stage: 'itn',
                  payload: {
                    apiKey: userAtom?.apikey,
                    businessId: userAtom?.businessid,
                    owWizardData: JSON.stringify({
                      ...owWizardDataParsed,
                      activeStep: 1,
                      business: {
                        name: values?.businessName,
                        location: values?.location,
                        teamSize: values?.teamSize,
                        crm: values?.crm,
                      },
                    }),
                  },
                });

              try {
                const [business, onboardingWizard] = await Promise.allSettled<
                  any
                >([
                  updateOnboardingAccountSettings(),
                  updateOnboardingWizard(),
                ]);

                const isSuccessful = (result) =>
                  result.status === 'fulfilled' ||
                  (result.status === 'rejected' &&
                    result.reason.response?.status === 304);

                if (isSuccessful(business) && isSuccessful(onboardingWizard)) {
                  enqueueSnackbarWithStyles({
                    message: 'Successfully Updated Onboarding Wizard',
                    alertProps: { severity: 'success' },
                  });
                  handleStep(1);
                } else {
                  enqueueSnackbarWithStyles({
                    message: 'Encountered an error updating Onboarding Wizard',
                    alertProps: { severity: 'error' },
                  });
                }
              } catch (err) {
                enqueueSnackbarWithStyles({
                  message: 'Encountered an error updating Onboarding Wizard',
                  alertProps: { severity: 'error' },
                });
              }
            }}
          >
            {(formik) => (
              <div className="row">
                <div className="col-lg-8">
                  <FormikTextField
                    name="businessName"
                    formik={formik}
                    fullWidth
                    label="Business Name"
                    size="small"
                    required
                    variant="outlined"
                  />
                </div>
                <div className="col-lg-8">
                  {/* Business Hours */}
                  {businessLoadable.state !== 'hasValue' ? (
                    <>Loading...</>
                  ) : (
                    <>
                      <LabelledOutline label="Business Hours">
                        <div className="row">
                          <div className="col-lg-6">
                            {splitHours.map((string, index) => (
                              <div key={index}>
                                {string} <br />
                              </div>
                            ))}
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-end',
                              paddingRight: '50px',
                            }}
                            className="col-lg-6"
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.editButton}
                              onClick={handleShowBusinessHours}
                            >
                              Edit Business Hours
                            </Button>
                          </div>
                        </div>
                      </LabelledOutline>
                      {/* <br />
                      <br />
                      <br /> */}
                      <ModalWithStyles
                        onSubmit={(_event) => handleSubmitBusinessHours(formik)}
                        title={'Business Hours'}
                        show={showBusinessHours}
                        onHide={onHideBusinessHours}
                        isSubmitting={formik.isSubmitting}
                        size="lg"
                      >
                        <Scheduler
                          setSchedulableHours={handleSetSchedulableHours}
                          //insert formik value aki
                          schedulableHours={formik.values.businessHours}
                        />
                      </ModalWithStyles>
                    </>
                  )}
                </div>
                <div className="col-lg-8">
                  {/* <Typography>Location</Typography> */}
                  <LabelledOutline label="Location">
                    <Grid container spacing={1}>
                      {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <FormikTextField
                        name="location.fullName"
                        formik={formik}
                        fullWidth
                        label="Full Name"
                        size="small"
                        variant="outlined"
                      />
                    </Grid> */}
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <FormikTextField
                          name="location.address1"
                          formik={formik}
                          fullWidth
                          label="Address 1"
                          size="small"
                          required
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <FormikTextField
                          name="location.address2"
                          formik={formik}
                          fullWidth
                          label="Address 2"
                          size="small"
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
                        <FormikTextField
                          name="location.city"
                          formik={formik}
                          fullWidth
                          label="City"
                          required
                          size="small"
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                        {formik.values.location.country === 'US' ? (
                          <MaterialAutocomplete
                            name="location.state"
                            formik={formik}
                            disableClearable
                            type="text"
                            fullWidth
                            label="State"
                            required={formik.values.location.country === 'US'}
                            size="small"
                            variant="outlined"
                            defaultValue={formik.values.location.state}
                            renderOption={(props, option: any) => {
                              const stateName =
                                stateList?.find?.(
                                  (state) => state?.code === option
                                )?.name ?? '';
                              return <li {...props}>{stateName}</li>;
                            }}
                            getOptionLabel={(option: any) =>
                              stateList?.find?.(
                                (state) => state?.code === option
                              )?.name ?? ''
                            }
                            options={stateList.map((state) => state.code)}
                          />
                        ) : (
                          <FormikTextField
                            name="location.state"
                            formik={formik}
                            fullWidth
                            label="State/Province/Region"
                            size="small"
                            variant="outlined"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
                        <MaterialAutocomplete
                          name="location.country"
                          formik={formik}
                          disableClearable
                          type="text"
                          fullWidth
                          label="Country"
                          size="small"
                          variant="outlined"
                          defaultValue={'US'}
                          required
                          renderOption={(props, option: any) => {
                            const countryName =
                              countryList?.find?.(
                                (country) => country?.code === option
                              )?.name ?? '';
                            return <li {...props}>{countryName}</li>;
                          }}
                          getOptionLabel={(option: any) =>
                            countryList?.find?.(
                              (country) => country?.code === option
                            )?.name ?? ''
                          }
                          options={countryList.map((country) => country.code)}
                          onChange={(event, value, reason) => {
                            if (value !== 'US') {
                              // Remove State dropdown for other countries
                              formik.setFieldValue('location.state', '');
                            }
                            formik.setFieldValue('location.country', value);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                        <FormikTextField
                          name="location.postalCode"
                          formik={formik}
                          fullWidth
                          label="ZIP/Postal Code"
                          size="small"
                          required={formik.values.location.country === 'US'}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </LabelledOutline>
                </div>
                <div className="col-lg-8">
                  <FormikSelect
                    name="teamSize"
                    className={classes.teamSelect}
                    formik={formik}
                    label="How big is your company?"
                    size="small"
                    required
                    variant="outlined"
                  >
                    {teamSelectOptions.map((option, i) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </div>
                <div className="col-lg-8">
                  <FormikSelect
                    name="crm"
                    className={classes.teamSelect}
                    formik={formik}
                    label="Select the CRM you are using"
                    size="small"
                    variant="outlined"
                    required
                  >
                    {crmList.map((option, i) => (
                      <MenuItem key={option} value={option}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                        >
                          <div>
                            <Avatar
                              alt={option}
                              src={`${getCRMIcon(option)}`}
                            />
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            {getCRMName(option)}
                          </div>
                        </div>
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </div>
                {/* <div className="col-lg-8">
                  <FormControl>
                    <p style={{ marginTop: '20px' }}>
                      Can your agents listen to anyone’s calls?
                    </p>
                    <RadioGroup
                      row
                      aria-labelledby="radio-buttons-group-onlyManagersCanViewCallReporting"
                      name="onlyManagersCanViewCallReporting"
                      style={{ marginLeft: '13px' }}
                      value={formik.values.onlyManagersCanViewCallReporting}
                      onChange={(e) => {
                        formik.setFieldValue(
                          'onlyManagersCanViewCallReporting',
                          Number((e.target as any).value)
                        );
                      }}
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </div> */}
                <div className="col-lg-8">
                  <div style={{ padding: '24px 0px 24px' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => handleNext(e, formik)}
                      className={onboardingClasses.button}
                      disabled={!formik.isValid}
                      endIcon={<ArrowForwardIcon />}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </Formik>
        </div>
      )}
    </>
  );
};

export default AccountSettings;
